/* eslint-disable arrow-body-style */

export const alphabeticalSort = (value1: string, value2: string) => {
    return value1.localeCompare(value2);
};
